import { render, staticRenderFns } from "./SvgFloorplan.vue?vue&type=template&id=bcf5bc54&"
import script from "./SvgFloorplan.vue?vue&type=script&lang=js&"
export * from "./SvgFloorplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports